import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import * as Yup from "yup";
import { toast } from "react-toastify";
import Select from "react-select";
import { FaSpinner } from "react-icons/fa";

const ITDeclarationAdd = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Add IT Declaration"));
  }, []);

  const initialFormData = {
    Code: "",
    Name: "",
    Description: "",
    IsGroup: 0,
    GroupID: null,
    ITSectionTypes: null,
    IsDeclarationRequired: 0,
    IsConsiderAsLabel: 0,
    IsDependOnPayroll: 0,
    IsConveyanceAllowance: 0,
    IsHouseRentAllowance: 0,
    IsRebateApplicable: 0,
    PayrollIDs: null,
    Sequence: null,
  };

  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState(initialFormData);
  const [groupOptions, setGroupOptions] = useState([]);
  const [itSectionTypeOption, setItSectionTypesOPtions] = useState([]);
  const [payrollOptions, setPayrollOptitos] = useState([]);
  useEffect(() => {
    fetchITDeclarationList();
  }, []);

  const fetchITDeclarationList = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}income/tax/sections`);
      if (response.status === 200) {
        const cleanedData = response?.data;
        const grpOPt = cleanedData?.group?.map((ele, index) => ({
          value: ele?.value,
          label: ele?.text,
        }));
        setGroupOptions(grpOPt);

        const payrollOpt = cleanedData?.payroll?.map((ele) => ({
          value: ele?.value,
          label: ele?.text,
        }));
        setPayrollOptitos(payrollOpt);

        const sectionTypeOpt = cleanedData?.type?.map((ele) => ({
          value: ele?.value,
          label: ele?.text,
        }));
        setItSectionTypesOPtions(sectionTypeOpt);

        setLoading(false);
      } else {
        console.error(
          "Failed to fetch partner Master. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Partner Master:", error);
    }
  };

  const [errors, setErrors] = useState({});

  const schema = Yup.object().shape({
    Code: Yup.string().required("Code is required"),
    Name: Yup.string().required("Name is required"),
  });

  const validateField = async (fieldName, value) => {
    try {
      // Create an object for the specific field to validate
      const fieldData = { [fieldName]: value };
      const fieldSchema = Yup.object().shape({
        [fieldName]: schema.fields[fieldName],
      });

      // Validate the specific field
      await fieldSchema.validate(fieldData, { abortEarly: false }); // Ensure all validation is checked

      // Clear the error for the specific field
      setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: "" }));
    } catch (err) {
      if (err.path === fieldName) {
        // Update the error only for the specific field
        setErrors((prevErrors) => ({
          ...prevErrors,
          [fieldName]: err.message,
        }));

        // Optional: Show a toast for errors specific to certain fields
        if (fieldName.startsWith("Slabs")) {
          toast.error(err.message, { position: "top-right" });
        }
      } else {
        console.error("Unexpected validation structure:", err);
      }
    }
  };
  const handleSelect = async (selectedOption, name) => {
    const value = selectedOption.value;
    setFormData((prevData) => {
      const updatedData = { ...prevData, [name]: value };

      // Trigger validation for the specific field after updating
      validateField(name, value);

      return updatedData;
    });
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevState) => ({ ...prevState, [name]: value }));

    // Validate this field on change
    validateField(name, value);
  };

  const handleCheckboxChange = async (e) => {
    const { name, checked } = e.target;

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: checked == true ? 1 : 0,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Validate all fields in the schema
      await schema.validate(formData, { abortEarly: false });

      // Clear all errors on successful validation
      setErrors({});

      // Call the API to submit data
      const response = await PostServiceCaller(
        `${API_URL}income/tax/sections`,
        formData,
        "post"
      );

      if (response.status === 200) {
        toast.success("Data submitted successfully");

        setTimeout(() => navigate("/rujul/hrm/it-declaration"), 1000);
      } else {
        console.error(
          "Failed to submit data. Server responded with status:",
          response.status
        );
        console.error("Response data:", response.data);
      }
    } catch (error) {
      if (error.name === "ValidationError") {
        console.error("Validation Error:", error);

        // Map validation errors to fields
        const validationErrors = {};
        error.inner.forEach((err) => {
          validationErrors[err.path] = err.message;
        });
        setErrors(validationErrors);
      } else {
        console.error("Unexpected Error:", error);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="Container">
      <form onSubmit={handleSubmit} id="formOne" className="rounded mt-2 bg-white">
        <div className="row row-flex g-1">
          {/** Grid one */}
          <div className="col-md-6 flex-col mt-1">
            <div class="card">
              <div class="card-header">
                <h5 className="subheading">General Details</h5>
              </div>
              <div className="card-body">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label className="form-label">
                        Code<span className="required">*</span>
                      </label>
                      <input
                        type="text"
                        name="Code"
                        placeholder="Code"
                        value={formData?.Code}
                        className={`${
                          errors.Code ? "is-invalid" : ""
                        } form-control`}
                        onChange={handleChange}
                      />
                      {errors.Code && (
                        <div className="invalid-feedback">{errors.Code}</div>
                      )}
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label className="form-label">
                        Name <span className="required">*</span>
                      </label>
                      <input
                        type="text"
                        name="Name"
                        placeholder="Name"
                        className={`${
                          errors.Name ? "is-invalid" : ""
                        } form-control`}
                        value={formData?.Name}
                        onChange={handleChange}
                      />
                      {errors.Name && (
                        <div className="invalid-feedback">{errors.Name}</div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div class="form-group">
                      <label className="form-label">Description</label>
                      <textarea
                        type="text"
                        name="Description"
                        placeholder="Description"
                        className={` form-control`}
                        value={formData?.Description}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div class="form-group">
                      <label className="form-label">Group</label>
                      <Select
                        options={groupOptions}
                        name="GroupID"
                        value={groupOptions?.find(
                          (o) => o.value === formData?.GroupID
                        )}
                        onChange={(selectedOptions, action) =>
                          handleSelect(selectedOptions, action.name)
                        }
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <div class="form-group">
                      <label className="form-label">IT Section Type</label>
                      <Select
                        options={itSectionTypeOption}
                        name="ITSectionTypes"
                        value={itSectionTypeOption?.find(
                          (o) => o.value === formData?.ITSectionTypes
                        )}
                        onChange={(selectedOptions, action) =>
                          handleSelect(selectedOptions, action.name)
                        }
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-check me-3 mt-3">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="IsGroup"
                        name="IsGroup"
                        checked={formData?.IsGroup}
                        onChange={handleCheckboxChange}
                      />
                      <label className="form-check-label">As Group</label>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-check me-3 mt-3">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="IsConsiderAsLabel"
                        name="IsConsiderAsLabel"
                        checked={formData?.IsConsiderAsLabel}
                        onChange={handleCheckboxChange}
                      />
                      <label className="form-check-label">
                        Is Consider As Label
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 flex-col mt-1">
            <div class="card">
              <div class="card-header">
                <h5 className="subheading">Additional Details</h5>
              </div>
              <div className="card-body">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label className="form-label">Sequence</label>
                      <input
                        type="text"
                        name="Sequence"
                        placeholder="Sequence"
                        value={formData?.Sequence}
                        className={`form-control`}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-check me-3 mt-3">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="IsDependOnPayroll"
                        name="IsDependOnPayroll"
                        checked={formData?.IsDependOnPayroll}
                        onChange={handleCheckboxChange}
                      />
                      <label className="form-check-label">
                        Is Depend On Payroll
                      </label>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label className="form-label">Payroll</label>
                      <Select
                        options={payrollOptions}
                        isDisabled={
                          formData?.IsDependOnPayroll === 0 ? true : false
                        }
                        value={payrollOptions?.find(
                          (o) => o.value === formData?.PayrollIDs
                        )}
                        name="PayrollIDs"
                        onChange={(selectedOptions, action) =>
                          handleSelect(selectedOptions, action.name)
                        }
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-check me-3 mt-3">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="IsDeclarationRequired"
                        name="IsDeclarationRequired"
                        checked={formData?.IsDeclarationRequired}
                        onChange={handleCheckboxChange}
                      />
                      <label className="form-check-label">
                        Is Declaration Required
                      </label>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-check me-3 mt-3">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="IsConveyanceAllowance"
                        name="IsConveyanceAllowance"
                        checked={formData?.IsConveyanceAllowance}
                        onChange={handleCheckboxChange}
                      />
                      <label className="form-check-label">
                        Consider as Conveyance Allowance
                      </label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-check me-3 mt-3">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="IsHouseRentAllowance"
                        name="IsHouseRentAllowance"
                        checked={formData?.IsHouseRentAllowance}
                        onChange={handleCheckboxChange}
                      />
                      <label className="form-check-label">
                        Consider as HRA
                      </label>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <div className="form-check me-3 mt-3">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="IsRebateApplicable"
                        name="IsRebateApplicable"
                        checked={formData?.IsRebateApplicable}
                        onChange={handleCheckboxChange}
                      />
                      <label className="form-check-label">
                        Is Rebate Applicable
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="container">
            <div className="d-flex justify-content-end mt-2">
              <div className="d-flex">
                <div>
                  <button
                    type="button"
                    className="cancel-btn me-2"
                    onClick={() => navigate(`/rujul/hrm/it-declaration`)}
                  >
                    Cancel
                  </button>
                </div>
                <div>
                  <button
                    disabled={loading ? true : false}
                    type="submit"
                    className=" custom-btn"
                  >
                    {loading ? <FaSpinner class="sm-spinner" /> : "Submit"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default ITDeclarationAdd;
